import { N8N_WEBHOOK_URL } from "./constants";
import { EVALUATION_TYPES } from "./constants";
import { buildN8nPayload } from "./utils";
import type { FormData, GeneratedContent } from "./types";

export const fetchUserData = async (token: string) => {
  if (!token) return null;

  try {
    const response = await fetch("/api/v1/users/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      return await response.json();
    }
  } catch (err) {
    console.error("Erro ao buscar dados do usuário:", err);
  }
  return null;
};

export const generateProvaWithAI = async (
  formData: FormData,
): Promise<GeneratedContent> => {
  const payload = buildN8nPayload(formData, EVALUATION_TYPES);

  const response = await fetch(N8N_WEBHOOK_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Erro ao gerar conteúdo com IA");
  }

  const data = await response.json();

  /**
   * N8N may return either:
   * - a single object
   * - or an array with a single object
   *
   * Normalize the response to always work with a single object.
   */
  const responseData = Array.isArray(data) ? data[0] : data;

  if (
    responseData.success &&
    responseData.plano_aula &&
    responseData.avaliacao
  ) {
    return responseData;
  }

  throw new Error("Resposta inválida da IA");
};
